module.exports = __webpack_public_path__ + "img/game4.fb4aa5bd.png";